import {fetchRepository} from '@github-ui/item-picker/RepositoryPicker'
import {useQuery} from '@github-ui/react-query'
import {useRelayEnvironment} from 'react-relay'

export function useRepoQuery({owner, repo}: {owner?: string; repo?: string}) {
  const environment = useRelayEnvironment()

  return useQuery({
    queryKey: ['copilot-immersive-current-repo', JSON.stringify(environment), owner, repo],
    queryFn: async () => {
      if (!owner || !repo) {
        return null
      }

      return await fetchRepository(environment, owner, repo)
    },
  })
}
